import React from 'react';
import {
  DataChart,
  TimeFrameButtons,
  DividerCard,
} from '../../../../components';
import { Divider, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  participantEngagement: {},
  participantInvestment: {
    display: 'block',
  },
  horizontalBarChart: {
    display: 'block',
  },
  '@media print': {
    participantEngagement: {
      marginTop: '200px',
    },
    participantInvestment: {
      marginTop: '-340px',
      marginLeft: '500px',
    },
    horizontalBarChart: {
      marginLeft: '-15px',
    },
  },
});

const PlanSponsorSummaryView = ({
  timeFrames,
  updateTimeFrame,
  chartTimeFrame,
  planSponsorSummaryData,
  participantAgeRanges,
  participantInvestments,
  filtered,
  horizontalBarChart,
  showFields,
  updateCustomTimeFrame,
}) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('md'));

  const participantAgeRange = participantAgeRanges
    ?.map((x) => ({
      label: x.ageRange,
      value: x.unmanaged,
      stackedValue: x.managed,
    }))
    .reverse();

  const participantInvestment = participantInvestments
    ?.filter((x) => x.strategyName !== 'Unknown')
    .map((x) => ({
      label: `${x.strategyName} (${x.total})`,
      value: x.total,
    }));

  return (
    <>
      <Grid
        container
        className={classes.participantEngagement}
        direction={isDesktop ? 'row' : 'column'}
        justifyContent="space-between"
      >
        <Grid item>
          <Typography
            variant="overline"
            color="textPrimary"
            style={{ fontWeight: 800, letterSpacing: 0.6 }}
          >
            PARTICIPANT ENGAGEMENT SUMMARY
          </Typography>
        </Grid>
        <Grid
          item
          style={
            isDesktop ? { marginTop: -16 } : { marginTop: 16, marginLeft: -16 }
          }
        >
          <TimeFrameButtons
            timeFrames={timeFrames}
            onChange={updateTimeFrame}
            currentTimeFrame={chartTimeFrame}
            showFields={showFields}
            customOnChange={updateCustomTimeFrame}
          />
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="space-evenly"
        spacing={2}
        direction={isDesktop ? 'row' : 'column'}
        style={{ paddingTop: 8, marginBottom: 8 }}
      >
        <Grid item xs>
          <DividerCard
            header="Started Gap Analysis"
            value={filtered?.startedGapAnalysis ?? 0}
            loading={planSponsorSummaryData == null}
            spacing={isDesktop}
          />
        </Grid>
        <Divider flexItem orientation="vertical" />
        <Grid item xs>
          <DividerCard
            header="Completed Gap Analysis"
            value={filtered?.completedGapAnalysis ?? 0}
            loading={planSponsorSummaryData == null}
            spacing={isDesktop}
          />
        </Grid>
        <Divider flexItem orientation="vertical" />
        <Grid item xs>
          <DividerCard
            header="Total Participant Support Interactions"
            value={filtered?.totalCustomerInteractions ?? 0}
            loading={planSponsorSummaryData == null}
            spacing={isDesktop}
          />
        </Grid>
      </Grid>
      <Grid
        container
        style={{ paddingTop: 16, marginTop: 16 }}
        className={classes.horizontalBarChart}
      >
        {planSponsorSummaryData?.topInteractions != null &&
        horizontalBarChart != null ? (
          filtered.totalCustomerInteractions !== 0 ? (
            <Grid item xs={12} md={12}>
              {horizontalBarChart}
            </Grid>
          ) : (
            <></>
          )
        ) : (
          <Skeleton
            variant="rect"
            style={{ borderRadius: 8 }}
            width={960}
            height={160}
          />
        )}
      </Grid>
      <Divider
        style={{ marginTop: 32, marginBottom: 32, breakAfter: 'page' }}
        flexItem
      />
      <Grid
        container
        direction={isDesktop ? 'row' : 'column'}
        justifyContent="flex-start"
        alignItems="center"
        spacing={isDesktop ? 2 : 4}
        style={{ paddingTop: 16 }}
      >
        <Grid item container md={6} xs={12}>
          <Grid item md={12} xs={12} style={{ marginBottom: 16 }}>
            <Typography
              variant="overline"
              color="textPrimary"
              style={{ fontWeight: 800, letterSpacing: 0.6 }}
            >
              PARTICIPANT AGE RANGES
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <DataChart
              loading={planSponsorSummaryData == null}
              data={participantAgeRange ?? []}
              type="bar"
              isStacked={true}
              skeleHeight="calc(100% + 2px)"
              skeleWidth="calc(100% + 4px)"
              skeleMargin={0}
              skelePadding={0}
            />
          </Grid>
        </Grid>
        {isDesktop && <Divider flexItem orientation="vertical" />}
        <Grid
          item
          container
          md={5}
          xs={12}
          className={classes.participantInvestment}
        >
          <Grid item md={12} xs={12} style={{ marginBottom: 16 }}>
            <Typography
              variant="overline"
              color="textPrimary"
              style={{ fontWeight: 800, letterSpacing: 0.6 }}
            >
              PARTICIPANT INVESTMENT STRATEGY SUMMARY
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <DataChart
              loading={planSponsorSummaryData == null}
              data={participantInvestment ?? []}
              type="donut"
              skeleHeight="calc(100% + 28px)"
              skeleWidth="calc(100% + 23px)"
              skeleMargin={1}
              skelePadding={0}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default PlanSponsorSummaryView;
